import React, { useEffect, useState } from 'react'
import { CRow, CCol } from '@coreui/react'
import StatsCard from './components/StatsCard'
import BookmarkCard from './components/BookmarkCard'
import { fs } from '../firebase'
import moment from 'moment'
import RecentBookMarks from './components/dashboard/RecentBookMarks'
import Stats from './components/dashboard/Stats'
import VerseOfDay from './components/dashboard/VerseOfDay'

export default function Dashboard() {

  return (
    <>
      <CRow>
        <CCol>
          <h4>Dashboard</h4>
        </CCol>
      </CRow>
      
      {/* <Stats /> */}
      
      <VerseOfDay />

      <RecentBookMarks />
    </>
  )
}
